// Encrypt function: Encodes the input text to base64

const encryptData = (text) => {
  try {
    return btoa(unescape(encodeURIComponent(text)));
  } catch (e) {
    console.error("Error during encryption:", e);
    return null;
  }
};

// Decrypt function: Decodes the base64 string back to original text
const decryptData = (text) => {
  try {
    return decodeURIComponent(escape(atob(text)));
  } catch (e) {
    console.error("Error during decryption:", e);
    return null;
  }
};

module.exports = { encryptData, decryptData };
